import React from "react";
import {Dashboard} from "../../_metronic/_partials";

function DashboardPage() {
  return <Dashboard/>;
}
export default DashboardPage;